import urlPrefix from "./apiPrefix";

export const postUserRecovery = () => `${urlPrefix.value}/tax-web-control/user/recovery`;
export const postUserRecoveryPassword = () => `${urlPrefix.value}/tax-web-control/user/recovery/password`;
